import { FC } from 'react';
import { ApolloProvider as ApolloProviderLib } from '@apollo/client';
import { client } from 'shared/api';

export const ApolloProvider: FC = ({ children }) => (
  <ApolloProviderLib client={client}>{children}</ApolloProviderLib>
);
